import { Container, TextContainer } from 'components/container'
import { AnimatedFigcaption } from 'components/animated-figcaption'
import { Title } from 'components/misc'
import DollImage from './assets/doll.webp'
import { Figure, Description, Image, Section } from './styled'

export const Doll = () => {
  return (
    <section>
      <TextContainer>
        <Title>Куклы акань</Title>
        <p>
          С одной стороны, обычная детская игрушка, но на самом деле акань имеет
          очень важное религиозное значение. У нее нет лица и конечностей. В
          мифологии коми считалось, что изображение лица или придание
          человеческой формы может позволить злым силам вселиться в куклу и
          нанести вред ребенку. Следовательно, отсутствие лица и конечностей
          оставляло куклу неодушевленным предметом. Зато у нее есть грудь – как
          символ женского божества, олицетворяющего материнство и плодородие.
        </p>

        <p>
          Коми верили, что одежда наделена мистическим смыслом и представляет
          собой тень-оберег человека. Поэтому если сшить из нее куклу, то ее
          можно потом использовать для ритуалов, например навести порчу на
          ненавистного человека.
        </p>
      </TextContainer>
      <Section>
        <Container>
          <Figure>
            <Image src={DollImage} alt="" />
            <Description>
              <AnimatedFigcaption
                FigCaptionComponent="div"
                description={
                  <p>
                    Кукла акань и ее одежда шились исключительно из новой ткани
                  </p>
                }
              />
            </Description>
          </Figure>
        </Container>
      </Section>
    </section>
  )
}
